import { CuoteoDatosDTO, CuoteoResultadoDTO } from "@DTOS";

export namespace CuoteoAcciones {
    export class CargarDatos {
        static readonly type = "[Cuoteo] Cargar datos cuoteo";
        constructor(public datos: CuoteoDatosDTO, public datasetName: string, public datasetInfo: string) {}
    }

    export class CargarResultados {
        static readonly type = "[Cuoteo] Cargar resultados cuoteo";
        constructor(public resultados: CuoteoResultadoDTO) {}
    }

    export class ReiniciarDatos {
        static readonly type = "[Cuoteo] Reiniciar datos cuoteo";
    }
}
